// extracted by mini-css-extract-plugin
export default {"circularLoader":"loader_circularLoader__KfEck","rotate4":"loader_rotate4__Ibq+b","circularLoaderCircle":"loader_circularLoaderCircle__ncREF","dash4":"loader_dash4__lfsoO"};